import React from "react";
import classes from "./Event.module.css";
import ItemName from "../../../Util/ItemName";
import ReactDOMServer from 'react-dom/server';

const Item = props => {
    let filename = "bitem_"+ props.itemID +".png";
    if(props.itemID >= 1130 && props.itemID < 1230) {
        filename = "bitem_tr.png";
    }
    const name = "https://raw.githubusercontent.com/Leanny/leanny.github.io/master/seedchecker/img/items/" + filename;

    const itemName = ReactDOMServer.renderToStaticMarkup(<ItemName id={props.itemID} />)
    return <div className={classes.Item}><img src={name} alt={itemName} title={itemName} />{props.prob}{props.sign}</div>;
}

export default Item;